import { useQuery } from 'react-query';

import api from '@root/api/newApi';

export default function useCurrentUser() {
  return useQuery('user.currentUser', api.user.getCurrentUser);
}
